import React, { useEffect, useState } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import PropTypes from 'prop-types';
import fileSize from 'filesize';
import { storage } from '../../../../config/firebase';
import {
  NUMERIC_VALUE, getMediaRenderTag,
} from '../../../../utils';


function SendMedia(props) {
  const { data, mediaUploadComplete, scrollToBottom } = props;
  const [progressPer, setProgresPer] = useState(NUMERIC_VALUE.ZERO);

  const uploadMedia = () => {
    const uploadTask = storage.ref(`images/${data.file.name}`).put(data.file);
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * NUMERIC_VALUE.HUNDRED,
        );
        setProgresPer(progress);
      },
      () => {},
      () => {
        storage
          .ref('images')
          .child(data.file.name)
          .getDownloadURL()
          .then((url) => {
            mediaUploadComplete(data.id, url, data.file);
          });
      },
    );
  };
  useEffect(() => {
    data.file && uploadMedia();
    scrollToBottom && scrollToBottom();
  }, [data.file]);
  return (
    <div className="send-media-popover">
      {data.file && (
      <div className="message-window-media-box">
        <div className="send-media-popover-image">
          <img
            src={getMediaRenderTag(data.file)}
            alt="media"
            className="image-cover"
          />
          <CircularProgressbar
            value={progressPer}
            styles={buildStyles({
              pathColor: '#fff',
              trailColor: 'rgba(255, 255, 255, 0.2)',
            })}
          />
        </div>
        <div className="send-media-popover-detail">
          <p>{data.file.name}</p>
          <span>{fileSize(data.file.size)}</span>
        </div>
      </div>
      )}
      {!data.file && (
      <p>
        {data.message}
      </p>
      )}
    </div>
  );
}

SendMedia.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    file: PropTypes.shape({ name: PropTypes.string, size: PropTypes.number, type: PropTypes.string }),
    message: PropTypes.string,
  }).isRequired,
  mediaUploadComplete: PropTypes.func.isRequired,
  scrollToBottom: PropTypes.func,
};
SendMedia.defaultProps = {
  scrollToBottom: null,
};

export default React.memo(SendMedia);
